import { CheckBoxField } from 'components/Form/CheckBoxField/CheckBoxField';
import { CheckBoxPropsType } from 'components/Form/CheckBoxField/CheckBoxField.types';
import checkboxSecondaryVariantTheme from './CheckboxSecondaryVariant.theme';

type CheckboxSecondaryVariantProps = Omit<
  CheckBoxPropsType,
  'labelPosition' | 'customCheckboxTheme'
>;

const CheckboxSecondaryVariant = (props: CheckboxSecondaryVariantProps) => {
  return (
    <CheckBoxField
      {...props}
      customCheckboxTheme={checkboxSecondaryVariantTheme}
      labelPosition="RIGHT"
    />
  );
};

export default CheckboxSecondaryVariant;
